var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountBoxOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 69.3335C72.8366 69.3335 80 62.1701 80 53.3335C80 44.4969 72.8366 37.3335 64 37.3335C55.1634 37.3335 48 44.4969 48 53.3335C48 62.1701 55.1634 69.3335 64 69.3335Z",
    stroke: "#182F86",
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69.3335C72.8366 69.3335 80 62.1701 80 53.3335C80 44.4969 72.8366 37.3335 64 37.3335C55.1634 37.3335 48 44.4969 48 53.3335C48 62.1701 55.1634 69.3335 64 69.3335Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6668 90.6668C90.6668 78.8802 78.7255 69.3335 64.0002 69.3335C49.2748 69.3335 37.3335 78.8802 37.3335 90.6668",
    stroke: "#182F86",
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6668 90.6668C90.6668 78.8802 78.7255 69.3335 64.0002 69.3335C49.2748 69.3335 37.3335 78.8802 37.3335 90.6668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16H32C23.1634 16 16 23.1634 16 32V96C16 104.837 23.1634 112 32 112H96C104.837 112 112 104.837 112 96V32C112 23.1634 104.837 16 96 16Z",
    stroke: "#182F86",
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16H32C23.1634 16 16 23.1634 16 32V96C16 104.837 23.1634 112 32 112H96C104.837 112 112 104.837 112 96V32C112 23.1634 104.837 16 96 16Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBoxOutlined);
export default __webpack_public_path__ + "static/media/account-box-outlined.75da09beffcc55999f6c8c423b645f41.svg";
export { ForwardRef as ReactComponent };